// mockNetworkHandler.ts
import { GraphQLResponse, RequestParameters } from 'relay-runtime';
import { Variables } from 'react-relay';
import { getMockResponse } from './getMockResponse';
export const mockNetworkHandler = (
  params: RequestParameters,
  variables: Variables,
): Promise<GraphQLResponse> => {
  console.log(`Mock request for ${params.name} with`, variables);
  return Promise.resolve(getMockResponse(params.name, variables));
};
